import type { OpportunityItem } from '../types'

function parseDateToMs(value?: string | null): number {
  if (!value) return 0
  const ms = Date.parse(value)
  return Number.isFinite(ms) ? ms : 0
}

// Ordenação da seção Encerradas deve seguir a mesma data exibida no bloco
// "Sinais (Entrada / Alvos / Stop)", que usa `publishedAt` (data do sinal).
export function getClosedOpportunitySignalsColumnTimestamp(
  item: Pick<OpportunityItem, 'publishedAt' | 'closedAt'>,
): number {
  const publishedAtMs = parseDateToMs(item.publishedAt)
  if (publishedAtMs) return publishedAtMs
  return parseDateToMs(item.closedAt)
}

